const angular = require('angular');

const walletModule = require('../wallet/wallet.module');
const { paymentDigitalPayComponentDefinition } = require('./payment-digital-pay.component'),
    { digitalPayInstrumentsComponentDefinition } = require('./digital-pay-instruments.component'),
    { stagedAmountDisplayComponentDefinition } = require('./staged-amount-display.component');

const digitalPayModuleName = 'wowApp.digitalpay';

angular.module(digitalPayModuleName, [walletModule])
    .component('wowPaymentDigitalPay', paymentDigitalPayComponentDefinition)
    .component('wowDigitalPayInstruments', digitalPayInstrumentsComponentDefinition)
    .component('wowStagedAmountDisplay', stagedAmountDisplayComponentDefinition);

require('./account');
require('./creditcard');
require('./giftcard');
require('./paypal');
require('./services');

module.exports = digitalPayModuleName;



// WEBPACK FOOTER //
// ./src/digitalpay/digitalpay.module.js